export default __webpack_public_path__ + "static/media/antenatalCare.c14c138e.svg";